import { render, staticRenderFns } from "./mobile-contacts.vue?vue&type=template&id=1bb1ed83"
import script from "./mobile-contacts.vue?vue&type=script&lang=js"
export * from "./mobile-contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports